import { render, staticRenderFns } from "./TransferRelationsModal.vue?vue&type=template&id=705dc935&scoped=true&"
import script from "./TransferRelationsModal.vue?vue&type=script&lang=ts&"
export * from "./TransferRelationsModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferRelationsModal.vue?vue&type=style&index=0&id=705dc935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705dc935",
  null
  
)

export default component.exports